<script>
  export let value = 0;
  export let currency = 'GBP'
  export let locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
</script>
{new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value).replace(/^(\D+)/, '$1 ')}